<template lang="pug">
  #Carrito
    Header

    //- ── Breadcrumb ─────────────────────────────────────────────────────────
    div.breadcrumb-bar
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='11')
            div.breadcrumb-inner
              a.bread-link(href='/') Inicio
              span.bread-sep /
              span.bread-current Carrito de compra

    //- ── Tabs carritos ──────────────────────────────────────────────────────
    div.car-tabs-bar(v-if='carritosExtra && carritosExtra.length > 0')
      v-tabs(v-model='tabActivo' color='#0F4DFF' background-color='white' show-arrows)
        v-tab
          v-icon(left small) mdi-cart-outline
          | Mi carrito
          v-chip(v-if='car.length > 0' x-small color='#0F4DFF' dark style='margin-left:6px;') {{car.length}}
        v-tab(v-for='(cex, ci) in carritosExtra' :key='ci')
          v-icon(left small) mdi-file-excel
          | Carrito importado {{ci + 1}}
          v-chip(x-small color='#e53e3e' dark style='margin-left:6px;') {{cex.length}}

    //- ── Contenido ──────────────────────────────────────────────────────────
    div.car-page
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')

            //- ── Carrito importado activo ────────────────────────────────────
            div(v-if='tabActivo > 0 && carritosExtra && carritosExtra[tabActivo - 1]')
              v-row
                v-col(cols='12' md='8')
                  div.car-table-head(v-if='pantalla >= 820')
                    span(style='flex:2') Producto
                    span(style='flex:1;text-align:center') Código
                    span(style='flex:1;text-align:center') Cantidad
                    span(style='flex:1;text-align:right') Total
                    span(style='width:40px')
                  div.car-list
                    div.car-row(v-for='(item, ii) in carritosExtra[tabActivo - 1]' :key='item.co_art' v-if='pantalla >= 820')
                      div.car-row-prod
                        div.car-row-info
                          span.car-row-name {{item.art_des}}
                          span(style='font-size:11px;color:#a0aec0;') {{item.co_art ? item.co_art.trim() : ''}}
                      div.car-row-price-col
                        span.car-row-price(v-if='mostrarP') ${{precioUnit(item)}}
                      div.car-row-qty-col
                        div.car-qty-ctrl
                          v-btn(icon x-small @click='restarExtra(tabActivo-1, ii)' class='car-qty-btn').elevation-0
                            v-icon(size='16') mdi-minus
                          span.car-qty-num {{item.cant}}
                          v-btn(icon x-small @click='sumarExtra(tabActivo-1, ii)' class='car-qty-btn').elevation-0
                            v-icon(size='16') mdi-plus
                      div.car-row-sub-col
                        span.car-row-sub(v-if='mostrarP') ${{(precioUnit(item) * item.cant).toFixed(2)}}
                      v-btn(icon small @click='borrarExtra(tabActivo-1, ii)' class='car-row-del').elevation-0
                        v-icon(color='#c0c8d8' size='18') mdi-trash-can-outline
                    div.car-row-mobile(v-for='(item, ii) in carritosExtra[tabActivo - 1]' :key='item.co_art + "m"' v-if='pantalla < 820')
                      div.car-row-info
                        span.car-row-name {{item.art_des}}
                        span(style='font-size:11px;color:#a0aec0;') {{item.co_art ? item.co_art.trim() : ''}}
                        div.car-row-meta
                          v-btn(icon x-small @click='restarExtra(tabActivo-1, ii)' class='car-qty-btn').elevation-0
                            v-icon(size='14') mdi-minus
                          span.car-row-qty {{item.cant}}
                          v-btn(icon x-small @click='sumarExtra(tabActivo-1, ii)' class='car-qty-btn').elevation-0
                            v-icon(size='14') mdi-plus
                          span.car-row-price(v-if='mostrarP') ${{precioUnit(item)}}
                        span.car-row-sub(v-if='mostrarP') Total: ${{(precioUnit(item) * item.cant).toFixed(2)}}
                      v-btn(icon small @click='borrarExtra(tabActivo-1, ii)' class='car-row-del').elevation-0
                        v-icon(color='#c0c8d8' size='18') mdi-trash-can-outline

                v-col(cols='12' md='4')
                  div.car-summary
                    div.car-summary-title
                      v-icon(size='18' color='#1a1a2e') mdi-receipt-text-outline
                      span Resumen del pedido
                    div.car-summary-row
                      span Subtotal ({{carritosExtra[tabActivo - 1].length}} productos)
                      span(v-if='mostrarP') ${{totalExtra(tabActivo - 1)}}
                    v-divider.my-3
                    div.car-summary-total
                      span Total
                      span(v-if='mostrarP') ${{totalExtra(tabActivo - 1)}}
                    div.car-obs-wrap
                      v-textarea(v-model='instruccionesExtra' outlined dense hide-details rows='3' label='Observación (opcional)' placeholder='Ej: Entregar en horario de mañana...' style='font-size:13px;')
                    div.car-terms
                      v-checkbox(v-model='checkk' hide-details='' color='#FF6200')
                      div.car-terms-text
                        | Acepto los
                        a.car-terms-link(@click='dialog = !dialog') Términos y Políticas de Devolución
                    div.car-actions
                      v-btn(@click='procesarExtra(tabActivo - 1)' :disabled='!checkk' class='car-btn-checkout').elevation-0
                        v-icon(left size='16') mdi-check-circle-outline
                        | Procesar pedido
                      v-btn(@click='eliminarExtra(tabActivo - 1)' class='car-btn-clear').elevation-0
                        v-icon(left size='16') mdi-delete-sweep-outline
                        | Eliminar carrito

            //- ── Carrito principal ───────────────────────────────────────────
            v-row(v-if='tabActivo === 0 || !carritosExtra || carritosExtra.length === 0')

              //- ── Lista de productos ──────────────────────────────────────
              v-col(cols='12' md='8')

                //- Header tabla (solo desktop)
                div.car-table-head(v-if='pantalla >= 820')
                  span(style='flex:2') Producto
                  span(style='flex:1;text-align:center') Precio
                  span(style='flex:1;text-align:center') Cantidad
                  span(style='flex:1;text-align:center') Total
                  span(style='width:40px')

                //- Items
                div.car-list
                  //- Vista mobile
                  div.car-row-mobile(v-for='item in car' :key='item._id + "m"' v-if='pantalla < 820')
                    div.car-row-img
                      img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url' class='car-row-img-src')
                      img(v-else-if='item.images && item.images.url' :src='ruta + item.images.url' class='car-row-img-src')
                      img(v-else src='@/assets/imgFerco/image.png' class='car-row-img-src')
                    div.car-row-info
                      span.car-row-name {{item.art_des || item.nombre}}
                      div.car-row-meta
                        span.car-row-qty x{{item.cant}}
                        span.car-row-price(v-if='mostrarP') ${{precioUnit(item)}}
                      span.car-row-sub(v-if='mostrarP') Total: ${{subtotal(item)}}
                    v-btn(icon small @click='borrar(item)' class='car-row-del').elevation-0
                      v-icon(color='#c0c8d8' size='18') mdi-trash-can-outline

                  //- Vista desktop
                  div.car-row(v-for='item in car' :key='item._id' v-if='pantalla >= 820')
                    div.car-row-prod
                      div.car-row-img
                        img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url' class='car-row-img-src')
                        img(v-else-if='item.images && item.images.url' :src='ruta + item.images.url' class='car-row-img-src')
                        img(v-else src='@/assets/imgFerco/image.png' class='car-row-img-src')
                      div.car-row-info
                        span.car-row-name {{item.art_des || item.nombre}}
                    div.car-row-price-col
                      span.car-row-price(v-if='mostrarP') ${{precioUnit(item)}}
                      span(v-if='!mostrarP') —
                    div.car-row-qty-col
                      div.car-qty-ctrl
                        v-btn(icon x-small @click='restar(item)' class='car-qty-btn').elevation-0
                          v-icon(size='16') mdi-minus
                        span.car-qty-num {{item.cant}}
                        v-btn(icon x-small @click='sumar(item)' class='car-qty-btn').elevation-0
                          v-icon(size='16') mdi-plus
                    div.car-row-sub-col
                      span.car-row-sub(v-if='mostrarP') ${{subtotal(item)}}
                      span(v-if='!mostrarP') —
                    v-btn(icon small @click='borrar(item)' class='car-row-del').elevation-0
                      v-icon(color='#c0c8d8' size='18') mdi-trash-can-outline

                  //- Vacío
                  div.car-empty(v-if='!car || car.length == 0')
                    v-icon(size='64' color='#d0d5e0') mdi-cart-off
                    span Tu carrito está vacío
                    v-btn(@click='$router.push("/productos")' class='car-empty-btn').elevation-0
                      | Ver productos

              //- ── Resumen ──────────────────────────────────────────────
              v-col(cols='12' md='4')
                div.car-summary
                  div.car-summary-title
                    v-icon(size='18' color='#1a1a2e') mdi-receipt-text-outline
                    span Resumen del pedido

                  div.car-summary-row
                    span Subtotal ({{car.length}} producto{{car.length != 1 ? 's' : ''}})
                    span(v-if='mostrarP') ${{total}}
                    span(v-if='!mostrarP') —

                  v-divider.my-3

                  div.car-summary-total
                    span Total
                    span(v-if='mostrarP') ${{total}}
                    span(v-if='!mostrarP') —

                  //- Observación
                  div.car-obs-wrap(v-if='car && car.length > 0')
                    v-textarea(v-model='instrucciones' outlined dense hide-details rows='3' label='Observación (opcional)' placeholder='Ej: Entregar en horario de mañana...' style='font-size:13px;')

                  //- Checkbox términos
                  div.car-terms(v-if='car && car.length > 0')
                    v-checkbox(v-model='checkk' hide-details='' color='#FF6200')
                    div.car-terms-text
                      | Acepto los
                      a.car-terms-link(@click='dialog = !dialog') Términos y Políticas de Devolución

                  //- Botones
                  div.car-actions(v-if='car && car.length > 0')
                    v-btn(@click='revisar()' :disabled='!checkk' class='car-btn-checkout').elevation-0
                      v-icon(left size='16') mdi-check-circle-outline
                      | Procesar compra
                    v-btn(@click='limpiar()' class='car-btn-clear').elevation-0
                      v-icon(left size='16') mdi-delete-sweep-outline
                      | Limpiar carrito
    //===========================================================Modal Politicas==============================================================================================
    v-dialog(v-model='dialog' transition='dialog-bottom-transition' max-width='800')
      template(v-slot:default='dialog')
        v-card
          v-toolbar(color='rgb(255, 87, 0)' dark='') TÉRMINOS Y POLÍTICAS DE DEVOLUCIÓN
          v-card-text
            div(style='padding: 48px 30px 0px 30px !important;').text-h2.black--text La empresa FERCOVEN CA., aceptará la devolución de algún producto siempre y cuando cumpla con todas y cada una de las condiciones que se establecen en la siguiente política de devoluciones:
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 1.	El plazo máximo para procesar una devolución de producto por: defecto, faltante, incompleto o maltratado será de <b style='text-decoration: underline;'>cuarenta y ocho (48)</b> horas continuas a partir de la fecha de recepción de la factura, sin excepciones. Es importante confirmar el estado físico de los bultos.
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 2.	Las devoluciones de mercancía <b style='text-decoration: underline;'>FRÁGIL</b> solo procederán cuando la mercancía sea revisada al momento de la entrega (Contra camión) y devuelta en el mismo momento. No procederán reclamos posteriores.
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 3.	El Producto deberá encontrarse completo, con los sellos intactos, empaques, manuales y accesorio deben ser originales, el empaque o la caja del producto no debe estar rayada, rota, sucia o con otra forma de maltrato o deterioro.
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 4.	No se aceptan devoluciones por baja rotación de inventario o por error en el Pedido imputable al Cliente.
            div(style='padding: 20px 30px 0px 30px !important;').text-h2.black--text Las Políticas de Devolución no aplican en las siguientes situaciones:
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 1.	El producto haya sido usado, instalado de forma incorrecta.
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 2.	El producto fue vendido por una promoción especial o remate.
            div(style='padding: 20px 55px 0px 55px !important;').text-h2.black--text 3.	El producto haya sido recibido bajos características especiales  (lo cual implica aceptación del producto).
            div(style='padding: 20px 30px 0px 30px !important;').text-h2.black--text En caso de proceder la devolución, será reembolsada por medio de una nota de crédito aplicable a una factura actual o futura; y/o cambio por cambio del producto (según existencias) en ningún caso se desembolsará dinero.
          v-card-actions.justify-end
            v-btn(text='' @click='dialog.value = false') Cerrar
    //===========================================================Modal Espera==============================================================================================
    v-dialog(v-model='loading2', persistent max-width='400px' style='background:#f1f2f1')
      v-container(style='max-width: 400px;background:#f1f2f1')
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h4.black--text  Esperando Respuesta del Servidor.!!
                v-flex(xs12)
                    div(style='display: flex;justify-content: center;').text-xs-center
                      img(src='../assets/waiting.gif', with='200' ,height='150')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h5.black--text  Por favor espere...
    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import { EventBus } from '../Events.js'
import { serverImg } from '@/services/environment'
import { mapState } from 'vuex'
export default {
  name: 'Carrito',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      car: [],
      tabActivo: 0,
      instruccionesExtra: '',
      checkk: false,
      dialog: false,
      loading2: false,
      mostrarP: false,
      instrucciones: '',
      pantalla: window.innerWidth,
      ruta: serverImg
    }
  },
  computed: {
    ...mapState(['carritosExtra']),
    total () {
      let total = 0
      for (let i = 0; i < this.car.length; i++) {
        const equi = parseFloat(this.car[i].equivalente) || 1
        const precioUnit = parseFloat(this.car[i].precio) / equi
        total = parseFloat(total) + parseFloat(this.car[i].cant * precioUnit)
      }
      return parseFloat(total.toFixed(2))
    }
  },
  created () {
    if (this.$store.state.carFerco !== null) {
      this.car = this.$store.state.carFerco
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
    }
    this.initialize()
  },
  methods: {
    precioUnit (item) {
      const equi = parseFloat(item.equivalente) || 1
      return parseFloat((parseFloat(item.precio) / equi).toFixed(2))
    },
    subtotal (item) {
      const total = parseFloat(item.cant) * this.precioUnit(item)
      return parseFloat(total.toFixed(2))
    },
    revisar () {
      if (this.$store.state.fercoWeb && this.$store.state.fercoWeb._id) {
        console.log(this.$store.state.fercoWeb)
        console.log(this.$store.state.fercoWeb.saldo_deudor <= 0)
        if (this.total >= 100) {
          if (this.$store.state.fercoWeb.saldo_deudor <= 0) {
            this.$swal
              .fire({
                title: '¿Estás seguro?',
                text: 'No podrás revertir esta operación!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, Continuar!'
              })
              .then(result => {
                console.log(result)
                if (result.value) {
                  let iva = 0
                  const art = []
                  let url
                  for (let i = 0; i < this.car.length; i++) {
                    const el = this.car[i]
                    iva += el.cant * el.precio * (el.iva / 100)
                    art.push({
                      ...el,
                      precio: {
                        monto: el.precio,
                        co_precio: el.co_precio
                      }
                    })
                  }
                  let cont = 0
                  let contD = 0
                  for (let i = 0; i < art.length; i++) {
                    const el = art[i]
                    if (el.campo8 && el.campo8.trim() == 'IVA') cont++
                    if (el.campo8 && el.campo8.trim() == 'DYLLU') contD++
                  }
                  if (cont == 0 || cont == art.length) {
                    url = 'pedido'
                    if (cont > 0) this.pedido.allIva = true
                    if (contD > 0) url = 'pedido/dyllu'
                  } else url = 'pedido/iva'
                  const info = {
                    articulos: art,
                    iva: iva,
                    co_cond: this.$store.state.fercoWeb.co_cond,
                    moneda: 'US$',
                    cliente: {
                      co_cli: this.$store.state.fercoWeb.co_cli,
                      contrib: this.$store.state.fercoWeb.contrib,
                      cli_des: this.$store.state.fercoWeb.cli_des,
                      co_zon: this.$store.state.fercoWeb.co_zon,
                      rif: this.$store.state.fercoWeb.rif
                    },
                    vendedor: {
                      co_ven: this.$store.state.fercoWeb.co_ven,
                      co_us_in: this.$store.state.fercoWeb.co_us_in,
                      sucu_in: this.$store.state.fercoWeb.sucu_in,
                      ven_des: this.$store.state.fercoWeb.ven_des
                    },
                    descrip: this.instrucciones ? this.instrucciones : 'Pedido web'
                  }
                  this.loading2 = true
                  Api.post(url, info)
                    .then(res => {
                      let msg = ''
                      if (res.data && res.data.pedidos && res.data.pedidos.length > 1) {
                        let str = ''
                        res.data.pedidos.forEach((el, i) => {
                          if (i == (res.data.pedidos.length - 1)) {
                            str += el.doc_num.trim()
                          } else str += el.doc_num.trim() + ' / '
                        })
                        msg = 'Los pedidos nros: ' + str + ' se ha registrado exitosamente.'
                      } else msg = 'El pedido nro: ' + res.data.pedidos[0].doc_num.trim() + ' se ha registrado exitosamente.'
                      this.loading2 = false
                      this.$swal
                        .fire({
                          title: '¡Felicidades!',
                          text: msg,
                          icon: 'success',
                          confirmButtonColor: '#3085d6',
                          confirmButtonText: 'Aceptar'
                        })
                        .then(() => {
                          this.$store.dispatch('vaciarcarrito')
                          this.car = this.$store.state.carFerco
                          EventBus.$emit('actCarrito')
                          this.$router.push('/')
                        })
                    })
                    .catch(err => {
                      this.loading2 = false
                      console.error(err)
                    })
                }
              })
          } else {
            this.$swal.fire(
              '¡Atención!',
              'Estimado usuario, para realizar la compra no puede tener facturas con mora.',
              'info'
            )
          }
        } else {
          this.$swal.fire(
            '¡Atención!',
            'Estimado usuario, la compra debe tener un minimo de 100$ para poder realizarla.',
            'info'
          )
        }
      } else {
        this.$router.push('/ingreso')
      }
    },
    restar (item) {
      const info = {
        ...item
      }
      if (info.cant) {
        const vald = parseFloat(info.cant) - parseFloat(info.equivalente)
        if (vald >= 0) {
          info.cant = parseFloat(info.cant) - parseFloat(info.equivalente)
        }
      } else {
        info.cant = 0
      }
      this.$store.dispatch('modificarcarrito', info)
    },
    disponibilidad (item, unidad) {
      let equi
      for (let i = 0; i < item.unidades.length; i++) {
        if (unidad === item.unidades[i]) {
          equi = i
        }
      }
      if (equi === 0) {
        return item.stock
      } else {
        return Math.round(item.stock * item.equivalencia[equi])
      }
    },
    sumar (item) {
      // let prod = {}
      // for (let i = 0; i < this.car.length; i++) {
      //   if (this.car[i]._id === item._id) {
      //     prod = this.car[i]
      //   }
      // }
      // if ((item.cant + 1) <= item.stock) {
      //   this.$store.dispatch('sumar', item)
      // }
      const vald = parseFloat(item.cant) + parseFloat(item.equivalente)
      if (vald <= Math.trunc(this.disponibilidad(item, item.unidad))) {
        const info = {
          ...item
        }
        info.cant = vald
        this.$store.dispatch('sumar', info)
      }
    },
    limpiar () {
      this.$store.dispatch('vaciarcarrito')
      this.car = this.$store.state.carFerco
      EventBus.$emit('vaciar')
    },
    borrar (item) {
      this.$store.dispatch('eliminar', item)
      this.car = this.$store.state.carFerco
    },
    totalExtra (idx) {
      const cart = this.$store.state.carritosExtra[idx]
      if (!cart) return '0.00'
      return cart.reduce((sum, i) => {
        const equi = parseFloat(i.equivalente) || 1
        return sum + ((parseFloat(i.precio) / equi) * i.cant)
      }, 0).toFixed(2)
    },
    sumarExtra (cartIdx, itemIdx) {
      const item = this.$store.state.carritosExtra[cartIdx][itemIdx]
      const equi = item.equivalente || 1
      const stockUnidades = (item.stock || 0) * equi
      const nuevaCant = parseFloat(item.cant) + equi
      if (nuevaCant > stockUnidades) {
        this.$swal.fire({ icon: 'warning', title: 'Sin stock', text: `Stock disponible: ${Math.floor(stockUnidades)}`, timer: 2000, showConfirmButton: false })
        return
      }
      this.$store.dispatch('setItemCantExtra', { cartIdx, itemIdx, cant: nuevaCant })
    },
    restarExtra (cartIdx, itemIdx) {
      const item = this.$store.state.carritosExtra[cartIdx][itemIdx]
      const equi = item.equivalente || 1
      const nuevaCant = parseFloat(item.cant) - equi
      if (nuevaCant <= 0) {
        this.$swal.fire({
          title: '¿Eliminar producto?',
          text: `${item.art_des} será eliminado del carrito`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar'
        }).then(r => {
          if (r.value) this.$store.dispatch('setItemCantExtra', { cartIdx, itemIdx, cant: 0 })
        })
        return
      }
      this.$store.dispatch('setItemCantExtra', { cartIdx, itemIdx, cant: nuevaCant })
    },
    borrarExtra (cartIdx, itemIdx) {
      this.$store.dispatch('setItemCantExtra', { cartIdx, itemIdx, cant: 0 })
    },
    eliminarExtra (idx) {
      this.$store.dispatch('eliminarCarritoExtra', idx)
      this.tabActivo = 0
    },
    procesarExtra (idx) {
      const cart = this.$store.state.carritosExtra[idx]
      if (!cart || cart.length === 0) return
      if (!this.$store.state.fercoWeb || !this.$store.state.fercoWeb._id) {
        this.$router.push('/ingreso')
        return
      }
      const fw = this.$store.state.fercoWeb
      if (fw.saldo_deudor > 0) {
        this.$swal.fire('¡Atención!', 'Estimado usuario, para realizar la compra no puede tener facturas con mora.', 'info')
        return
      }
      const total = parseFloat(this.totalExtra(idx))
      if (total < 100) {
        this.$swal.fire('¡Atención!', 'La compra debe tener un mínimo de $100 para poder realizarla.', 'info')
        return
      }
      this.$swal.fire({
        title: '¿Estás seguro?',
        text: 'Se procesará este carrito importado como pedido.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, procesar'
      }).then(result => {
        if (!result.value) return
        let iva = 0
        const art = cart.map(el => {
          iva += el.cant * el.precio * ((el.iva || 0) / 100)
          return { ...el, precio: { monto: el.precio, co_precio: el.co_precio_sel || el.co_precio || '' } }
        })
        let cont = 0; let contD = 0
        art.forEach(el => {
          if (el.campo8 && el.campo8.trim() === 'IVA') cont++
          if (el.campo8 && el.campo8.trim() === 'DYLLU') contD++
        })
        let url = 'pedido'
        if (cont > 0 && cont !== art.length) url = 'pedido/iva'
        if (contD > 0) url = 'pedido/dyllu'
        const info = {
          articulos: art,
          iva,
          co_cond: fw.co_cond,
          moneda: 'US$',
          cliente: { co_cli: fw.co_cli, contrib: fw.contrib, cli_des: fw.cli_des, co_zon: fw.co_zon, rif: fw.rif },
          vendedor: { co_ven: fw.co_ven, co_us_in: fw.co_us_in, sucu_in: fw.sucu_in, ven_des: fw.ven_des },
          descrip: this.instruccionesExtra ? this.instruccionesExtra : 'Pedido web (importado)'
        }
        this.loading2 = true
        Api.post(url, info).then(res => {
          let msg = ''
          if (res.data && res.data.pedidos && res.data.pedidos.length > 1) {
            msg = 'Los pedidos: ' + res.data.pedidos.map(p => p.doc_num.trim()).join(' / ') + ' se registraron exitosamente.'
          } else {
            msg = 'El pedido nro: ' + res.data.pedidos[0].doc_num.trim() + ' se ha registrado exitosamente.'
          }
          this.loading2 = false
          this.$swal.fire({ title: '¡Felicidades!', text: msg, icon: 'success', confirmButtonText: 'Aceptar' })
            .then(() => {
              this.$store.dispatch('eliminarCarritoExtra', idx)
              this.tabActivo = 0
              EventBus.$emit('actCarrito')
            })
        }).catch(err => {
          this.loading2 = false
          console.error(err)
        })
      })
    },
    initialize () {
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/carrito.scss";
</style>
